import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["onUpdate:modelValue", "onChange", "id", "label"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-darkGray-1 mt-4 mb-1 flex items-center gap-2 col-span-full" }
const _hoisted_5 = { class: "text-darkGray-1 mb-1 flex items-center gap-2" }
const _hoisted_6 = { class: "flex col-span-full gap-4 mt-4" }

import {
  ref,
  reactive,
  onMounted,
  computed,
  watch,
} from "vue";
import InputText from "@/features/shared/components/form/InputText.vue";
import * as dtos from "@/models/dtos";
import "v-calendar/dist/style.css";
import { DynamicProperty, RadioItem } from "@/models/dtos";
import RegularButton from "@/features/shared/components/ui/RegularButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioGroupEditor',
  props: {
  model: {
    type: Object as () => dtos.DynamicProperty,
    required: true,
  },
  metadata: {
    type: Object as () => dtos.MetaData,
    required: true,
  },
},
  emits: ["add", "remove", "labelChange", "back", "removeField", "changeRadioLabel", "toggleRadioRequired"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const radioButtons = reactive(new Array<RadioItem>());

const withoutGroup = computed(() =>
  radioButtons.filter((px) => px.item.type !== "radioGroup")
);

const props = __props;
const isLoaded = ref(false);
const item = ref(props.model as dtos.DynamicProperty);
const isRequired = ref(false);

onMounted(() => {
  let properties = props.metadata.properties.filter((x) =>
    props.model.data.keys.includes(x.key)
  );
  properties.forEach((x) => {
    radioButtons.push(new RadioItem(x, x.label));
  });

  isRequired.value = item.value.validators?.find(
    (validator) => validator.name === "radioRequired"
  )?.data;
  isLoaded.value = true;
});

const onRequiredChange = () => {
  emit("toggleRadioRequired", isRequired.value);
};

const addNewRadio = () => {
  const newRadio = new dtos.DynamicProperty();

  newRadio.placeholder = "";
  newRadio.type = "radio";
  newRadio.key = crypto.randomUUID();
  newRadio.label = "";
  newRadio.data = false;
  radioButtons.push(new RadioItem(newRadio));

  emit("add", props.model.key, newRadio);
};

function onLabelChange(event: any) {
  emit("labelChange", event);
}

const removeRadio = (radio: RadioItem) => {
  const index = radioButtons.indexOf(radio);
  radioButtons.splice(index, 1);

  emit("remove", radio.item);
};
function onRadioLabelChange(event: any, key: string) {
  emit("changeRadioLabel", key, event.target.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "mb-4" }, "Dina förändringar sparas automatiskt.", -1)),
    _createElementVNode("form", {
      class: "grid gap-4",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createVNode(InputText, {
        keyId: "0",
        placeholder: item.value.label,
        label: "Rubrik för radiogrupp",
        model: item.value.label,
        type: "text",
        onChange: onLabelChange,
        class: "col-span-full"
      }, null, 8, ["placeholder", "model"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(withoutGroup.value, (radioButton, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "w-full grid grid-cols-12 gap-2",
          key: radioButton.item?.key
        }, [
          _createElementVNode("label", {
            class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold col-span-full",
            for: radioButton.item?.key
          }, "Radioknapp " + _toDisplayString(index + 1), 9, _hoisted_1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": ($event: any) => ((radioButton.label) = $event),
            onChange: 
          (e) => {
            onRadioLabelChange(e, radioButton.item.key);
          }
        ,
            type: "text",
            id: radioButton.item?.key,
            label: `radioknapp ${index + 1}`,
            placeholder: "Ange texten för radioknappen",
            class: "col-span-11 appearance-none block bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-3 px-4 leading-tight focus:bg-white focus:border-blue-1 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed"
          }, null, 40, _hoisted_2), [
            [_vModelText, radioButton.label]
          ]),
          _createElementVNode("i", {
            onClick: ($event: any) => (removeRadio(radioButton)),
            title: "Ta bort",
            class: "col-span-1 fas fa-trash-alt text-red-2 hover:text-red-2 text-2xl cursor-pointer"
          }, null, 8, _hoisted_3)
        ]))
      }), 128))
    ], 32),
    _createElementVNode("button", {
      onClick: addNewRadio,
      class: "mt-4 col-span-full flex gap-2 items-center text-blue-1 hover:text-blue-2 cursor-pointer"
    }, [...(_cache[5] || (_cache[5] = [
      _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
      _createElementVNode("span", null, "Lägg till radioknapp", -1)
    ]))]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isRequired).value = $event)),
          onChange: onRequiredChange
        }, null, 544), [
          [_vModelCheckbox, isRequired.value]
        ]),
        _cache[6] || (_cache[6] = _createTextVNode(" Obligatorisk ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(RegularButton, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('removeField', item.value))),
        "style-type": "cancel",
        text: "Ta bort gruppen"
      }),
      _createVNode(RegularButton, {
        onClick: _cache[3] || (_cache[3] = 
        () => {
          emit('back');
        }
      ),
        "style-type": "success",
        text: "Spara"
      }),
      _createVNode(RegularButton, {
        onClick: _cache[4] || (_cache[4] = 
        () => {
          emit('back');
        }
      ),
        text: "Tillbaka"
      })
    ])
  ], 64))
}
}

})